var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChargingStation = function SvgChargingStation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 13.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.2 4.6a.6.6 0 1 0-1.2 0h1.2m-1.2 4a.6.6 0 1 0 1.2 0H20m-5.8-4a.6.6 0 1 0-1.2 0h1.2m-1.2 4a.6.6 0 1 0 1.2 0H13m-3.3-4a.6.6 0 0 0-1.2 0h1.2m-1.2 4a.6.6 0 0 0 1.2 0H8.5m-3.3-4a.6.6 0 0 0-1.2 0h1.2M4 8.6a.6.6 0 0 0 1.2 0H4m-.4-8v.6h11V0h-11zm14 3H17v6h1.2v-6zm-3 9V12h-11v1.2h11zm-14-3h.6v-6H0v6zm3 3V12a2.4 2.4 0 0 1-2.4-2.4H0a3.6 3.6 0 0 0 3.6 3.6zm14-3H17a2.4 2.4 0 0 1-2.4 2.4v1.2a3.6 3.6 0 0 0 3.6-3.6zm-3-9v.6A2.4 2.4 0 0 1 17 3.6h1.2A3.6 3.6 0 0 0 14.6 0zm-11 0V0A3.6 3.6 0 0 0 0 3.6h1.2a2.4 2.4 0 0 1 2.4-2.4zm17 4H20v4h1.2v-4zm-7 0H13v4h1.2v-4zm-4.5 0h-.6v4h1.2v-4zm-4.5 0H4v4h1.2v-4z"
  })));
};
export default SvgChargingStation;